import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

export default function SearchBarDesktop() {
 const [keyword, setKeyword] = useState("");
 const navigate = useNavigate();

 const submitHandler = (e) => {
   e.preventDefault();

   if (keyword?.trim()) {
     navigate(`/products?keyword=${keyword}`);
   } else {
     navigate(`/`);
   }
  };
  
  return (
    <form onSubmit={submitHandler} className="custom-navbar-search">
      <input
        type="text"
        value={keyword}
        name="keyword"
        onChange={(e) => setKeyword(e.target.value)}
        placeholder="Part No. / Keyword"
      />
      {/* 搜索框内右侧的 BOM 上传入口，点击进入 BOM Order 页面 */}
      <Link to="/my-parts" className="custom-navbar-search-bom">
        {/* 内联 SVG 上传图标，避免依赖字体图标 CDN */}
        <svg
          className="custom-navbar-search-bom-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 15.5V4" />
          <path d="M7.5 8.5 12 4l4.5 4.5" />
          <path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3" />
        </svg>
        <span>Upload My Parts</span>
      </Link>
      <button
        className="btn btn-primary"
        type="submit"
      >
        <Image src="/img/search.png" alt="Search" />
      </button>
    </form>
  );
}
